<template>
  <v-card
    class="px-3 py-1 d-flex align-center user-item"
    elevation="0"
    rounded
    :to="`/profile/${organizationId}/${user._id}`"
    @click="handleClick"
  >
    <UserAvatar :account="user" size="36px" fontSize="12px" />
    <div
      class="d-flex flex-grow-1 align-center justify-space-between ms-2"
      style="width: 75%"
    >
      <span class="subtitle2 blue-grey--text text--darken-2 text-truncate">
        {{ getShortenedName(user) }}
      </span>
      <p class="subtitle2 blue-grey--text text--darken-3 mb-0 ml-2">
        {{ count }}
      </p>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import userMixin from '@/mixins/userMixin'
import mixin from '@/mixins/mixin.vue'
import UserAvatar from '@/components/UserAvatar.vue'

export default {
  name: 'UserItem',

  mixins: [userMixin, mixin],

  components: {
    UserAvatar,
  },

  props: {
    user: {
      type: Object,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    section: {
      typeString: String,
      default: '',
    },
  },

  computed: {
    ...mapGetters(['organizationId']),
  },

  methods: {
    handleClick() {
      this.$track('recognitions.Navigation', this.$store, {
        option: this.section,
      })
    },
  },
}
</script>
<style lang="scss">
.user-item:hover {
  background-color: $color-blue-grey-lighten3;
}
</style>
